import {
  localStorageLang,
  localStorageSideNav,
  PROM_HOME_ID,
  PROM_CAT_DRAMA_ID,
  PROM_CAT_ID,
  PROM_CAT_SPORT_ID,
  PROM_CAT_ENTS_ID,
  PROM_CAT_CYW_ID,
  PROM_CAT_STWNSH_ID,
  PROM_CAT_FACT_ID,
  PROM_CAT_MUSIC_ID,
  PROM_CAT_NEWS_ID,
  PROM_CAT_RELIGION_ID,
  PROM_CAT_RURAL_ID,
  PROM_CAT_SIGNED_ID,
  PROM_CAT_WW_ID,
  API_ROOT_LOCAL,
  API_ROOT_PROTOCOL,
  API_ROOT_HOST,
  DATA_FEEDS_PROTOCOL,
  DATA_FEEDS_HOST,
  BOXSET_ID,
  PROM_CAT_HANSH_ID,
  HANSH_ID,
  COMPETITION_DATE,
  API_ROOT_LIVE_CMS,
  LEARNERS_ID,
  PROM_CAT_LEARNERS_ID,
  WALTER_ID,
  PROM_CAT_WALTER_ID,
  HERE_ID,
  PROM_CAT_HERE_ID,
  DEEP_LINK_URL,
  SEARCH_CAT_MIN_CHARACTERS,
  localStorageSignedPref,
  localStorageTheme,
  API_ROOT_LIVE_CMS_V2,
  API_ROOT_STAGE_CMS_V2,
  CMS_PROGROW_TYPE_CATEGORY,
  CMS_PROGROW_TYPE_BOXSET,
  CMS_PROGROW_TYPE_PROGRAMMESET,
  API_ROOT_IMG_LIVE_CMS_V2,
  API_ROOT_IMG_STAGE_CMS_V2,
  DEFAULT_THEME,
  PATH_SIGN_IN,
  PATH_SIGN_UP,
  PATH_FORGOT,
  PATH_FORGOT_UPDATE,
} from './constants';
import moment from 'moment-timezone';
import { useEffect, useRef } from 'react';

export const feedURLBase =
  window.location.protocol + '//' + window.location.host;

export function isAppLocal() {
  const feedURLBase = window.location.protocol + '//' + window.location.host;
  const feedURLBaseStart = `${feedURLBase.split(':')[0]}:${
    feedURLBase.split(':')[1]
  }`;
  if (
    feedURLBaseStart === 'https://webmb01.local' ||
    feedURLBaseStart === 'http://localhost' ||
    feedURLBaseStart.indexOf('10.0.0.') !== -1
  ) {
    //return true;
    return false;
  } else {
    return false;
  }
}

export function iOS() {
  var iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];
  if (!!navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()) {
        return true;
      }
    }
  }
  return false;
}

export function cleanQueryString(stream) {
  let n = stream.indexOf('?');
  return n > -1 ? stream.slice(0, n) : stream;
}

export function isAndroid() {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}

export function grabCurrentPath() {
  var currentPath = window.location.pathname;
  if (currentPath.startsWith('/clic')) {
    var split = currentPath.split('/');
    split.splice(1, 1);
    currentPath = split.join('/');
  }
  return escape(currentPath);
}

export function apiBaseUrl(localOverride) {
  const envId = window.ENV_ID === 'live' ? 'www' : window.ENV_ID;
  const baseUrl = isAppLocal()
    ? localOverride
      ? localOverride
      : API_ROOT_LOCAL
    : `${API_ROOT_PROTOCOL}${envId}${API_ROOT_HOST}`;
  return baseUrl;
}

export function dataFeedsBaseUrl(localOverride) {
  const envId = window.ENV_ID === 'live' ? 'www' : window.ENV_ID;
  const baseUrl = isAppLocal()
    ? localOverride
      ? localOverride
      : API_ROOT_LOCAL
    : `${DATA_FEEDS_PROTOCOL}${envId}${DATA_FEEDS_HOST}`;
  return baseUrl;
}

export function cmsBaseUrl(localOverride) {
  return isAppLocal() ? API_ROOT_LOCAL : API_ROOT_LIVE_CMS;
}

export function initLang() {
  if (localStorage.getItem(localStorageLang) === null) {
    localStorage.setItem(localStorageLang, 0);
  }
}

export function initSideNav() {
  if (localStorage.getItem(localStorageSideNav) === null) {
    localStorage.setItem(localStorageSideNav, 0);
  }
}

export function replaceString(original, replace, index, length) {
  let start = original.substring(0, index);
  let end = original.substring(index + length, original.length);
  return start + replace + end;
}

export function checkLang(lang, double) {
  let language;
  if (!lang && lang !== 0) {
    language =
      localStorage.getItem(localStorageLang) === null
        ? 0
        : parseInt(localStorage.getItem(localStorageLang), 10);
  } else {
    language = lang;
  }

  if (double) {
    return parseInt(language, 10) === 0 ? 'cy' : 'en';
  } else {
    return parseInt(language, 10) === 0 ? 'c' : 'e';
  }
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className,
    nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += classString.length ? ' ' + className : className;
  } else {
    classString = classString.replace(' ' + className, '');
    classString = classString.replace(className, '');
  }
  element.className = classString;
}

export function hasClass(elem, className) {
  return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}

export function addClass(elem, className) {
  if (!hasClass(elem, className)) {
    elem.className += ' ' + className;
  }
}

export function removeClass(elem, className) {
  var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
  if (hasClass(elem, className)) {
    while (newClass.indexOf(' ' + className + ' ') >= 0) {
      newClass = newClass.replace(' ' + className + ' ', ' ');
    }
    elem.className = newClass.replace(/^\s+|\s+$/g, '');
  }
}

export function splitDate(dateStr) {
  // format expected 2013-04-02
  return dateStr.split('-');
}

export function joinDate(dobParts) {
  // format expected 2013-04-02
  dobParts[1] = ('00' + dobParts[1]).slice(-2); // ensure day and month have preceeding 0s
  dobParts[2] = ('00' + dobParts[2]).slice(-2);
  return dobParts.join('-');
}

export function twoDigitNum(val) {
  return (val < 10 ? '0' : '') + val;
}

export function formatTwelveHour(hours) {
  return hours <= 12 ? hours : hours === 24 || hours === 0 ? 0 : hours - 12;
}

export function timeFromDate(date, separator = '', twelveHour = 0) {
  const sep = separator === '' ? ':' : separator;
  const newDate = new Date(date);
  const valHours =
    twelveHour === 1
      ? formatTwelveHour(newDate.getUTCHours())
      : twoDigitNum(newDate.getHours());
  const valMin = twoDigitNum(newDate.getMinutes());
  return `${valHours}${sep}${valMin}`;
}

export const daysInWeekEnglish = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const daysInWeekWelsh = [
  'Dydd Sul',
  'Dydd Llun',
  'Dydd Mawrth',
  'Dydd Mercher',
  'Dydd Iau',
  'Dydd Gwener',
  'Dydd Sadwrn',
];
export const monthsInYearEnglish = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const monthsInYearWelsh = [
  'Ion',
  'Chwef',
  'Maw',
  'Ebr',
  'Mai',
  'Meh',
  'Gorff',
  'Awst',
  'Medi',
  'Hyd',
  'Tach',
  'Rhag',
];

export function selectDay(lang, d) {
  const arrayDays =
    parseInt(lang, 10) === 1 ? daysInWeekEnglish : daysInWeekWelsh;
  return arrayDays[d];
}

export function selectMonth(lang, m) {
  const arrayMonths =
    parseInt(lang, 10) === 1 ? monthsInYearEnglish : monthsInYearWelsh;
  return arrayMonths[m];
}

export function formatFromDate(lang, date) {
  const newDate = new Date(date);
  return `${newDate.getDate()} ${selectMonth(
    lang,
    newDate.getMonth()
  )} ${newDate.getFullYear()}`;
}

export function truncateStr(text, maxLength) {
  // grabbed this from stackoverflow and tweaked
  // https://stackoverflow.com/a/24168721

  if (maxLength === undefined) {
    maxLength = 42;
  }

  //if ( text !== undefined && text.length <= maxLength ) {
  if (text !== undefined && String(text).length <= maxLength) {
    return text;
  }

  var defaultOptions = {
    // By default we add an ellipsis at the end
    suffix: true,
    suffixString: '…',
    // By default we preserve word boundaries
    preserveWordBoundaries: true,
    wordSeparator: ' ',
  };

  // Compute suffix to use (eventually add an ellipsis)
  var suffix = '';
  if (text !== undefined && text.length > maxLength && defaultOptions.suffix) {
    suffix = defaultOptions.suffixString;
  }

  // Compute the index at which we have to cut the text
  var maxTextLength = maxLength - suffix.length;
  var cutIndex;
  if (defaultOptions.preserveWordBoundaries) {
    // We use +1 because the extra char is either a space or will be cut anyway
    // This permits to avoid removing an extra word when there's a space at the maxTextLength index
    if (text !== undefined) {
      var lastWordSeparatorIndex = text.lastIndexOf(
        defaultOptions.wordSeparator,
        maxTextLength + 1
      );
    }
    // We include 0 because if have a "very long first word" (size > maxLength), we still don't want to cut it
    // But just display "...". But in this case the user should probably use preserveWordBoundaries:false...
    cutIndex =
      lastWordSeparatorIndex > 0 ? lastWordSeparatorIndex : maxTextLength;
  } else {
    cutIndex = maxTextLength;
  }

  if (text !== undefined) {
    var newText = text.substr(0, cutIndex);
  }
  return newText + suffix;
}

export function decodeHtml(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

export function programmeTitle(seriesTitle, programmeTitle, programmeAired) {
  let title = decodeHtml(seriesTitle);
  let subTitle = decodeHtml(programmeTitle);

  if (!title || title === 'null') {
    title = subTitle;
    subTitle = programmeAired;
  }
  if (!subTitle || subTitle === 'null') {
    subTitle = programmeAired;
  }

  return { title, subTitle };
}

export function formatProgDetails(res) {
  const {
    id,
    series_id,
    series_title,
    programme_title,
    clic_aired,
    thumbnail_url,
    count,
  } = res;
  let prog = {};
  if (id) {
    let progTitles = {},
      thumbnail = 'default.jpg',
      isActions = false,
      isProgress = false,
      cardClass = '',
      progress = false;
    progTitles = programmeTitle(series_title, programme_title, clic_aired);
    thumbnail = thumbnail_url;
    prog = {
      id,
      series_id,
      title: progTitles.title,
      subTitle: progTitles.subTitle,
      thumbnail,
      isActions,
      isProgress,
      cardClass,
      progress,
      count,
    };
  }
  return prog;
}

export function moreProgrammeTitle(seriesTitle, programmeTitle) {
  let title = decodeHtml(seriesTitle);
  let subTitle = decodeHtml(programmeTitle);

  if (!title || title === 'null') {
    title = subTitle;
    subTitle = '';
  }
  if (!subTitle || subTitle === 'null') {
    subTitle = '';
  }

  return { title, subTitle };
}

export function formatMoreProgDetails(res) {
  const { id, series_title, programme_title, clic_aired, thumbnail_url } = res;
  let prog = {};
  if (id) {
    let progTitles = {},
      thumbnail = 'default.jpg',
      isActions = false,
      isProgress = false,
      cardClass = '',
      progress = false;
    progTitles = moreProgrammeTitle(series_title, programme_title, clic_aired);
    thumbnail = thumbnail_url;
    prog = {
      id,
      title: progTitles.title,
      subTitle: progTitles.subTitle,
      clic_aired,
      thumbnail,
      isActions,
      isProgress,
      cardClass,
      progress,
    };
  }
  return prog;
}

export function fetchPromoId(section, id) {
  id = parseInt(id, 10);
  let promoId = 0;
  if (section === '/') {
    promoId = PROM_HOME_ID;
  } else if (section.includes('Categories')) {
    switch (id) {
      case 0:
        promoId = PROM_CAT_ID;
        break;
      case 4:
        promoId = PROM_CAT_DRAMA_ID;
        break;
      case 5:
        promoId = PROM_CAT_SPORT_ID;
        break;
      case 3:
        promoId = PROM_CAT_ENTS_ID;
        break;
      case 13:
        promoId = PROM_CAT_CYW_ID;
        break;
      case 16:
        promoId = PROM_CAT_STWNSH_ID;
        break;
      case 1:
        promoId = PROM_CAT_FACT_ID;
        break;
      case 7:
        promoId = PROM_CAT_MUSIC_ID;
        break;
      case 6:
        promoId = PROM_CAT_NEWS_ID;
        break;
      case 8:
        promoId = PROM_CAT_RELIGION_ID;
        break;
      case 11:
        promoId = PROM_CAT_RURAL_ID;
        break;
      case 100:
        promoId = PROM_CAT_SIGNED_ID;
        break;
      case 99:
        promoId = PROM_CAT_WW_ID;
        break;
      case HANSH_ID:
        promoId = PROM_CAT_HANSH_ID;
        break;
      case LEARNERS_ID:
        promoId = PROM_CAT_LEARNERS_ID;
        break;
      case WALTER_ID:
        promoId = PROM_CAT_WALTER_ID;
        break;
      case HERE_ID:
        promoId = PROM_CAT_HERE_ID;
        break;
      default:
        break;
    }
  }

  return promoId;
}

export function touchClass() {
  var touchsupport =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  if (!touchsupport) {
    document.body.classList.add('non-touch');
  } else {
    document.body.classList.add('touch');
  }
}

export function formatTimeMin(lang, dateTime, strings, time_text) {
  //Format the Item Date and Time
  const item = new Date(dateTime);
  const itemDate = `${twoDigitNum(item.getDate())}-${twoDigitNum(
    item.getMonth() + 1
  )}-${item.getFullYear()}`;

  //Format today's date
  const now = new Date();
  const nowDate = `${twoDigitNum(now.getDate())}-${twoDigitNum(
    now.getMonth() + 1
  )}-${now.getFullYear()}`;

  //Then check if the item date is today
  const timeText =
    itemDate === nowDate
      ? `${strings[lang].todayAt} ${time_text}`
      : `${item.getDate()} ${selectMonth(lang, item.getMonth())} ${
          strings[lang].at
        } ${time_text}`;

  return timeText;
}

export function buildDeepLinkingURL() {
  return DEEP_LINK_URL + '?h=' + grabCurrentPath();
}

export function isIos9() {
  // function used here is only available in cordova env so test if exists first
  // if not exist assume false
  return typeof window.isIosDevice === 'function' && window.isIosDevice(9);
}

/**
 * A hacky check to see if currently casting
 */
export function isCasting() {
  return window.PlayerManager.isCasting();
}

export function isOffline() {
  return typeof window.offline === 'undefined' ? false : window.offline;
}

export function boxSetsImgOverrride(items = [], overrideIds, catId) {
  if (
    Object.keys(items).length > 0 &&
    catId === BOXSET_ID &&
    overrideIds &&
    overrideIds.length > 0
  ) {
    Object.entries(items).forEach(([key, value]) => {
      Object.entries(overrideIds).forEach(([OverKey, OverValue]) => {
        if (parseInt(value.id, 10) === parseInt(OverValue.id, 10)) {
          items[key].thumbnail = OverValue.img;
        } else {
          if (
            parseInt(value.series_id, 10) === parseInt(OverValue.series_id, 10)
          ) {
            items[key].thumbnail = OverValue.img;
          }
        }
      });
    });
  }
  return items;
}

export function isBrowserBadWithDateField() {
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;
  const isMac = navigator.platform.indexOf('Mac') !== -1;
  const isSafari =
    navigator.userAgent.search('Safari') >= 0 &&
    navigator.userAgent.search('Chrome') < 0;
  return isIE || (isMac && isSafari);
}

export function timeToSeconds(str) {
  // format can be "hh:mm:ss", "mm:ss" or "ss"
  // takes a time and returns total seconds
  //const p = str.split(':');
  const p = str && str.length > 0 ? str.split(':') : 0;
  let s = 0,
    m = 1;

  while (p.length > 0) {
    s += m * parseInt(p.pop(), 10);
    m *= 60;
  }

  return s;
}

export function returnWidthPercent(total, part) {
  // expecting 2 numbers
  return (100 / total) * part;
}

/*
export function 	isBoxSet(id) {
	return parseInt(BOXSET_ID, 10) === parseInt(id, 10) ? true: false;
}
*/

export function isGenreMatch(ids, genreID) {
  // use this is check if the genre ID of a programme matches a specific genre
  // IDs = can pass either integer or comma separated list of IDs as string
  // will convert to string and compare against passed ID
  // reason this can be either is that some programmes can be in multiple
  // genres so will return a string of IDs
  ids = ids + '';
  const idArray = ids.split(',');
  return idArray.includes(genreID + '');
}

export function genreExists(genres, ID) {
  // use this is check if a category exists - used for channels
  // pass the returned list of genres (array of objects)
  // [{id:Int,genre:Str}]
  let thisExists = false;

  if (Array.isArray(genres)) {
    for (let i = 0; i < genres.length; i++) {
      if (genres[i] !== undefined) {
        if (parseInt(genres[i].id, 10) === parseInt(ID, 10)) {
          thisExists = true;
          break;
        }
      }
    }
  }
  return thisExists;
}

export function isCompetition() {
  const dt1 = new Date();
  const dt2 = new Date(COMPETITION_DATE);

  return dt1 < dt2 ? true : false;
}

export function arrayContains(needle, arrhaystack) {
  return arrhaystack.indexOf(needle) > -1;
}

export function imageFallback(ev, path) {
  ev.target.onerror = null;
  ev.target.src = path;
}

export function wrapStr(string, keyword) {
  // return a string with the matching keyword
  // wrapped in a div. Returned string should
  // respect the original case, not overwrite
  // with the case of the keyword

  // escape any characters that will bork the regex
  keyword = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // eslint-disable-line

  // create regex that matches on any case
  // restricting to the first match at the moment
  const regex = new RegExp(`\\b${keyword}`, 'i');

  // capture matched string part
  let match = string.match(regex);

  // replace this matched string part
  // wrapped in a span
  if (match) {
    return string.replace(regex, `<span>${match}</span>`);
  } else {
    return string;
  }
}

export function filterArrayByValue(array, catMapping, string) {
  // eslint-disable-next-line no-useless-escape
  const keyword = string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(`\\b${keyword}`, 'i');
  let cats = [],
    match;
  if (array && array.length > 0) {
    for (let i = 0; i < array.length; i++) {
      match = array[i].genre.match(regex);
      if (match && match.length > 0) {
        cats.push(array[i]);
      }
    }
  }

  if (cats.length === 0) {
    if (
      catMapping &&
      catMapping.length > 0 &&
      string &&
      string.length >= SEARCH_CAT_MIN_CHARACTERS
    ) {
      for (let i = 0; i < catMapping.length; i++) {
        match = catMapping[i].item.match(regex);
        if (match && match.length > 0) {
          cats.push(catMapping[i]);
        }
      }
    }
  }

  return cats && cats.length > 0
    ? cats[Math.floor(Math.random() * cats.length)]
    : [];
}

export function getSearchCategories(keywords, categories) {
  let cats = [],
    found;
  if (
    keywords &&
    keywords.length >= SEARCH_CAT_MIN_CHARACTERS &&
    Object.keys(categories).length > 0
  ) {
    Object.entries(categories).forEach(([key, value]) => {
      if (categories[key].length > 0) {
        Object.entries(categories[key]).forEach(([key2, value2]) => {
          found = cats.some((el) => el.id === categories[key][key2]['id']);
          if (
            !found &&
            categories[key][key2]['id'] &&
            categories[key][key2]['genre']
          ) {
            cats.push({
              id: categories[key][key2]['id'],
              genre: categories[key][key2]['genre'],
            });
          }
        });
      }
    });
  }

  return cats;
}

export function highlightResultsText(ref, keywords, className) {
  if (ref) {
    const matchedTitles = ref.getElementsByClassName(className);

    Array.from(matchedTitles).forEach((el) => {
      el.innerHTML = wrapStr(el.dataset.string, keywords);
    });
  }
}

export function setSignedPref(signedId = 0) {
  localStorage.setItem(localStorageSignedPref, signedId);
}

export function getSignedPref() {
  if (
    !localStorage.getItem(localStorageSignedPref) ||
    localStorage.getItem(localStorageSignedPref) === null
  ) {
    localStorage.setItem(localStorageSignedPref, 0);
  }

  return localStorage.getItem(localStorageSignedPref);
}

export function cmsBaseUrlV2() {
  const prodUrl =
    window.ENV_ID === 'live' ||
    window.ENV_ID === 'www' ||
    window.ENV_ID === 'beta'
      ? API_ROOT_LIVE_CMS_V2
      : API_ROOT_STAGE_CMS_V2;
  return isAppLocal() ? API_ROOT_LOCAL : prodUrl;
}

export function getSelectedChannel(catIds, channels) {
  let selectedCat = {};
  if (catIds && catIds.length > 0 && channels && channels.length > 0) {
    catIds = catIds.split(',').map(Number);
    for (var i = 0; i < channels.length; i++) {
      if (catIds.includes(channels[i].categoryId)) {
        selectedCat = channels[i];
        break;
      }
    }
  }
  return selectedCat;
}

export function programmeRowName(programmeRow) {
  let name = '';
  if (programmeRow.type === CMS_PROGROW_TYPE_CATEGORY) {
    name = programmeRow.category.genre;
  } else if (programmeRow.type === CMS_PROGROW_TYPE_BOXSET) {
    name = programmeRow.boxSet.title;
  } else if (programmeRow.type === CMS_PROGROW_TYPE_PROGRAMMESET) {
    name = programmeRow.programmeSet.title;
  }
  return name;
}

export function cmsImageBaseUrlV2() {
  const prodUrl =
    window.ENV_ID === 'live' ||
    window.ENV_ID === 'www' ||
    window.ENV_ID === 'beta'
      ? API_ROOT_IMG_LIVE_CMS_V2
      : API_ROOT_IMG_STAGE_CMS_V2;
  return isAppLocal() ? API_ROOT_LOCAL : prodUrl;
}

export function isCmsImage(url) {
  let isCmsImg = false;
  if (url && !url.includes('amg/')) {
    isCmsImg = true;
  }
  return isCmsImg;
}

export function cmsImageResize(pathname, size) {
  return `${cmsImageBaseUrlV2()}/${size}/media/${pathname}`;
}

export function setTheme(theme = DEFAULT_THEME) {
  localStorage.setItem(localStorageTheme, theme);
  if (theme === 'light') {
    document.getElementsByTagName('html')[0].classList.remove('dark');
    document.getElementsByTagName('html')[0].classList.add('light');
  } else {
    document.getElementsByTagName('html')[0].classList.remove('light');
    document.getElementsByTagName('html')[0].classList.add('dark');
  }
}

export function getTheme() {
  if (
    !localStorage.getItem(localStorageTheme) ||
    localStorage.getItem(localStorageTheme) === null
  ) {
    localStorage.setItem(localStorageTheme, DEFAULT_THEME);
  }
  return localStorage.getItem(localStorageTheme);
}

export const formatUrl = (url) => {
  let newUrl = url;
  if (url.includes('/clic') || url.includes('/clic-prototype/')) {
    const urlStrip = url.replace(/^(?:\/\/|[^/]+)*\//, '');
    const urlSplit = urlStrip.split('/');
    const urlSigned = urlSplit[3] ? urlSplit[3] : '';
    newUrl = `/${urlSplit[1]}`;
    newUrl += urlSplit[2] ? `/${urlSplit[2]}` : '';
    newUrl += urlSigned ? `/${urlSigned}` : '';
  }

  if (/^(?:[a-z]+:)?\/\//i.test(newUrl)) {
    return url;
  } else {
    return newUrl;
  }
};

export const isOnNow = (currentTime, progTime, duration) => {
  const updatedNextTime = moment(progTime, 'HH:mm')
    .add(duration)
    .format('HH:mm');
  return currentTime >= progTime && currentTime < updatedNextTime;
};

export const convertMinsToHrsMins = (mins, strings) => {
  let h = Math.floor(mins / 60);
  let m = mins % 60;
  m = String(m).padStart(2, '0');
  return `${h} ${strings.hour} ${m} ${strings.minutes}`;
};

export const durationInMins = (time, strings) => {
  const split = time.split(':');
  const minutes = +split[0] * 60 + +split[1];
  return minutes > 60
    ? convertMinsToHrsMins(minutes, strings)
    : minutes + ' ' + strings.minutes;
};

export const getTheDate = (dateUrl) => {
  const urlArray = dateUrl.split('/').filter((str) => str);
  const date =
    urlArray[2] ||
    (() => {
      // Now defaulting to yesterday if no date supplied
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const year = currentDate.getFullYear();
      const month = twoDigitNum(currentDate.getMonth() + 1);
      const day = twoDigitNum(currentDate.getDate());
      return `${year}-${month}-${day}`;
    })();

  return date;
};

export const getTodaysDate = () => {
  const todaysDate = new Date();
  return {
    date: todaysDate,
    string: todaysDate.toISOString().substr(0, 10),
  };
};

export const isSignInUp =
  grabCurrentPath() === PATH_SIGN_IN ||
  grabCurrentPath() === PATH_SIGN_UP ||
  grabCurrentPath() === PATH_FORGOT ||
  grabCurrentPath() === PATH_FORGOT_UPDATE ||
  grabCurrentPath() === '/tv' ||
  grabCurrentPath() === '/linc' ||
  grabCurrentPath() === '/link';

export const titleTrunc = (width, title, isHero) => {
  let truncationLength;

  switch (true) {
    case width >= 2326:
      isHero ? (truncationLength = 90) : (truncationLength = 40);
      break;
    case width >= 2078:
      isHero ? (truncationLength = 90) : (truncationLength = 30);
      break;
    case width >= 1830:
      isHero ? (truncationLength = 90) : (truncationLength = 30);
      break;
    case width >= 1440:
      isHero ? (truncationLength = 90) : (truncationLength = 20);
      break;
    case width >= 768:
      isHero ? (truncationLength = 40) : (truncationLength = 14);
      break;
    case width >= 425:
      isHero ? (truncationLength = 28) : (truncationLength = 16);
      break;
    case width > 320:
      truncationLength = 14;
      break;
    default:
      truncationLength = 10;
      break;
  }
  return truncateStr(title, truncationLength);
};

export const getWidth = (setWidth) => {
  const updateWidth = () => {
    setWidth(window.innerWidth);
  };
  updateWidth();
  window.addEventListener('resize', updateWidth);
  return () => {
    window.removeEventListener('resize', updateWidth);
  };
};

export const getCurrentCategoryName = (id, categories, strings) => {
  let catArray = [];

  if (categories && Object.keys(categories).length > 0) {
    Object.entries(categories).forEach(([key, value]) => {
      Object.entries(value).forEach(([key2, value2]) => {
        if (value2.genre) {
          catArray.push({
            id: value2.id,
            genre: value2.genre,
          });
        }
      });
    });
    const matchingCategory = catArray.find((item) => item.id === id);
    return matchingCategory ? matchingCategory.genre : strings.categories;
  }
};

export const formatDateAndTime = (dateTime) => {
  // Regular expression to check the format: YYYY-MM-DDTHH:MM:SS.sssZ
  var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;

  // Check if the input matches the expected format
  if (!regex.test(dateTime)) {
    return { date: null, time: null };
  }

  var dt = new Date(dateTime);
  const dtMoment = moment.utc(dateTime);
  const londonTime = dtMoment.tz('Europe/London');
  const BSTTime = londonTime.format('HH:mm:ssZ');

  // Format the date as yyyy-mm-dd
  var date =
    dt.getUTCFullYear() +
    '-' +
    String(dt.getUTCMonth() + 1).padStart(2, '0') +
    '-' +
    String(dt.getUTCDate()).padStart(2, '0');
  // Extract the time and offset from the ISO string
  var isoString = dt.toISOString();
  var time = isoString.split('T')[1].split('.')[0]; // Extract time without milliseconds
  var offset = dt.getTimezoneOffset();
  // Convert offset to hours and minutes
  var offsetHours = Math.abs(parseInt(offset / 60));
  var offsetMinutes = Math.abs(offset % 60);
  // Format the offset
  var formattedOffset =
    (offset > 0 ? '-' : '+') +
    String(offsetHours).padStart(2, '0') +
    ':' +
    String(offsetMinutes).padStart(2, '0');
  return {
    date: date,
    time: time + formattedOffset,
    BSTTime: BSTTime,
  };
};

export const IsvgWrapper = ({ children, addClasses = '' }) => (
  <span className={`isvg loaded ${addClasses}`}>{children}</span>
);

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const hardExpired = (timeShifted, endDateTime, streamExpireDateTime) => {
  const now = new Date();

  if (!timeShifted && now > new Date(endDateTime)) {
    return true;
  }

  if (timeShifted && now > new Date(streamExpireDateTime)) {
    return true;
  }

  return false;
};

export function convertStrDate(dateStr) {
  const welshToEnglishMonths = {
    Ionawr: 'January',
    Chwefror: 'February',
    Mawrth: 'March',
    Ebrill: 'April',
    Mai: 'May',
    Mehefin: 'June',
    Gorffennaf: 'July',
    Awst: 'August',
    Medi: 'September',
    Hydref: 'October',
    Tachwedd: 'November',
    Rhagfyr: 'December',
  };

  // Check if the date is in Welsh
  for (let welshMonth in welshToEnglishMonths) {
    if (dateStr.includes(welshMonth)) {
      // Replace Welsh month with English month
      dateStr = dateStr.replace(welshMonth, welshToEnglishMonths[welshMonth]);
      break;
    }
  }

  // Create a Date object from the formatted date string
  const date = new Date(dateStr);

  // Format the date to the required format
  const isoString = date.toISOString();
  return isoString;
}
